export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    nameIt: 'Scarpe',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Scopri la collezione completa di scarpe: sneakers, sportive, eleganti e casual.',
    icon: 'ri-footprint-line',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    nameIt: 'Felpe/Maglioni',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Felpe con cappuccio e maglioni per ogni stagione, stili urban e casual.',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    nameIt: 'T-Shirt',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'T-shirt basic e stampate, cotone premium per il massimo comfort quotidiano.',
    icon: 'ri-shirt-line',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    nameIt: 'Giacche',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Giacche, bomber, giubbotti per un look streetwear sempre alla moda.',
    icon: 'ri-archive-line',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    nameIt: 'Pantaloni/Corti',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Jeans, cargo, pantaloncini: trova il fit perfetto per il tuo stile.',
    icon: 'ri-pantone-line',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    nameIt: 'Cappelli',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Cappellini snapback, bucket hat e berretti per completare ogni outfit.',
    icon: 'ri-base-station-line',
  },
  {
    id: 'sets',
    name: 'Sets',
    nameIt: 'Set Completi',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Set coordinati di abbigliamento per un look già pronto e impeccabile.',
    icon: 'ri-stack-line',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    nameIt: 'Intimo',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Intimo e biancheria di qualità, comfort e stile sotto ogni vestito.',
    icon: 'ri-user-heart-line',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    nameIt: 'Maglie Sportive',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Maglie da calcio, basket e sportive, design autentici e materiali traspiranti.',
    icon: 'ri-football-line',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    nameIt: 'Accessori',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Accessori moda per lui e lei: occhiali, gioielli, orologi e molto altro.',
    icon: 'ri-glasses-line',
  },
  {
    id: 'bags',
    name: 'Bags',
    nameIt: 'Borse',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Borse, zaini e tracolle per ogni occasione, dal lavoro al tempo libero.',
    icon: 'ri-handbag-line',
  },
  {
    id: 'belts',
    name: 'Belts',
    nameIt: 'Cinture',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Cinture in pelle e tessuto, dettaglio essenziale per uno stile ricercato.',
    icon: 'ri-link',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    nameIt: 'Profumi',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Fragranze esclusive per uomo e donna, scopri il profumo che ti rappresenta.',
    icon: 'ri-drop-line',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    nameIt: 'Altro',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Tutto il resto: gadget, articoli vari e sorprese da non perdere.',
    icon: 'ri-more-line',
  },
];